import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Backdrop, Box } from '@mui/material'

const Loading = ({ loaderColor, localized, localizedSx }) =>
  localized ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '300px',
        ...localizedSx,
      }}
    >
      <CircularProgress color={loaderColor} />
    </Box>
  ) : (
    <Backdrop open sx={{ zIndex: theme => theme.zIndex.drawer + 101 }}>
      <CircularProgress color={loaderColor} />
    </Backdrop>
  )

Loading.propTypes = {
  loaderColor: PropTypes.string,
  localized: PropTypes.bool,
  localizedSx: PropTypes.object,
}

Loading.defaultProps = {
  loaderColor: 'primary',
  localized: false,
  localizedSx: {},
}

export default Loading
